import { Link } from "react-router";
import { Gift } from "lucide-react";
import { SubsidySumupHoverCard } from "@/features/subventions/components/SubsidySumupHoverCard/SubsidySumupHoverCard";
import { SUBVENTIONS_PATH } from "@/features/subventions/routes";
import RoundedIconButton from "@/shared/components/customButtons/roundedIconButton";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/shared/components/ui/hover-card";

export const SubventionsIcon = () => {
  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <Link to={SUBVENTIONS_PATH} className="relative">
          <RoundedIconButton
            icon={Gift}
            ariaLabel="Subventions"
            className="[&_svg]:!transition-colors [&_svg]:!duration-[600ms] [&_svg]:!ease-in-out"
          />
        </Link>
      </HoverCardTrigger>
      <HoverCardContent className="w-80" align="end" side="bottom">
        <SubsidySumupHoverCard />
      </HoverCardContent>
    </HoverCard>
  );
};
